import React from 'react';
import { Link } from 'react-router-dom';

const LandingPageView = () => {
    return (
        <div className='w-full h-full flex flex-col items-center justify-center'>
            <div className='flex flex-col items-center justify-center'>
                <h1 className='text-3xl text-center'>Welcome to Space Guesser</h1>
                <img className='animate-spin-slow mt-5 mb-7 w-3/4 md:w-auto' src="/assets/images/solar-system.png" alt="solar system" />
                <div className='flex flex-col md:flex-row md:justify-center'>
                    <Link className='btn-primary mb-4 md:mb-0 md:mr-4' to="/login">Log in</Link>
                    <Link className='btn-primary' to="/signup">Sign up</Link>
                </div>
            </div>
        </div>
    );
};

export default LandingPageView;
